var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    _c("div", { staticClass: "page-titles p-3 border-bottom" }, [
      _c("h3", { staticClass: "text-themecolor" }, [
        _vm._v(_vm._s(_vm.trans("user.user")) + " \n            "),
        _vm.user.profile
          ? _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(
                _vm._s(
                  _vm.user.profile.first_name + " " + _vm.user.profile.last_name
                ) +
                  " (" +
                  _vm._s(_vm.user.email) +
                  ")"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm pull-right",
            on: {
              click: function ($event) {
                return _vm.$router.push("/account/users/general-partners")
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-sm-inline" }, [
              _vm._v("General Partners"),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0 pta-documents-premium",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-12 col-sm-8" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body p-4" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("user-sidebar", {
                        attrs: { menu: "documents", id: _vm.id },
                      }),
                      _vm._v(" "),
                      _vm.is_loaded
                        ? _c(
                            "div",
                            {
                              staticClass: "col-9 col-sm-9 pta-content-center",
                            },
                            [
                              _c("h4", { staticClass: "card-title" }, [
                                _vm._v("Documents"),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "pta-uploads" }, [
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Fact Sheet")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/fs2/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 1,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Presentation")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/ps2/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 2,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Team Bios")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/bios2/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 3,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Case Studies")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/cs/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 4,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("FAQ/DDQ")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/faqs/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 5,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Track Record")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/tr/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 6,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Financial Model")]),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 7,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Key Terms")]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pta-ai-link",
                                        attrs: {
                                          href: "/kt/" + _vm.id + "/pdf",
                                        },
                                      },
                                      [_vm._v("AI Generator")]
                                    ),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 8,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [_vm._v("Market Reports")]),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 9,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c("h3", [
                                      _vm._v("Any other marketing materials"),
                                    ]),
                                    _vm._v(" "),
                                    _c("file-upload-input", {
                                      attrs: {
                                        "button-text": "Choose file to upload",
                                        token: _vm.upload_token,
                                        module: "documents",
                                        "clear-file":
                                          _vm.clear_message_attachment,
                                        "module-id": 10,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("user-summary", { attrs: { user: _vm.user } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }